module.exports = __webpack_public_path__ + "img/125.8ab9433d.jpg";